import { jwtDecode } from 'jwt-decode';

// b2e token is valid for 75min, 5min margin to be sure we refresh it in time
export const EXPIRATION_MARGIN = 5 * 60_000;
export const TOKEN_REFRESH_PERIOD = 15 * 60_000;

function toMilliseconds(exp: number): number {
    return exp * 1000;
}

/**
 * @return true if token is valid false otherwise
 * @throws InvalidTokenError when token cannot be parsed
 */
export function tryIsValidToken(token: string): boolean {
    const decodedToken = jwtDecode<AccessToken>(token);
    const expirationTime = toMilliseconds(decodedToken.exp);
    return decodedToken && expirationTime > Date.now() + EXPIRATION_MARGIN;
}

/**
 * @return true if token is valid false otherwise. Undefined / parse errors resolve to false
 */
export function isValidToken(token: string | null): token is string {
    try {
        return !!token && tryIsValidToken(token);
        // eslint-disable-next-line sonarjs/no-ignored-exceptions
    } catch (_) {
        return false;
    }
}

interface AccessToken {
    exp: number;
}
